import React from "react";
import { useTranslation } from "react-i18next";
import { useChatContext } from "../chat_context.jsx";

export default function ChatWelcomeMessage() {
  const { t } = useTranslation("labels");
  const { fileInfo, folderInfo } = useChatContext();
  
  return (
    <div className="text-center py-5">
      <i className="fa-solid fa-robot fa-3x text-primary mb-3"></i>
      <h4 className="text-primary">{t("chatWithAi", { ns: "labels" })}</h4>
      <p className="text-muted">
        {t("askMe", { ns: "labels" })} {(fileInfo ?? folderInfo)?.Name}
      </p>
    </div>
  );
}
